export default {"src":"/_next/static/media/xsg.defba064.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};